import {injectable} from 'inversify';

import type {CoreClientDiaryEntriesCreateParams} from '../../../../../../api/types/core/methods';
import type {CoreDiaryEntryApiModel} from '../../../../../../api/types/core/models';
import type {ApiReadResponse} from '../../../../../../api/types/types';

import {apiRequest} from '../../../../../../api/utils/apiRequest';
import {CreateDiaryEntryCmd} from '../CreateDiaryEntry.cmd';

@injectable()
export class CreateDiaryEntryCmdJrpc implements CreateDiaryEntryCmd {
  async exec(
    props: CreateDiaryEntryCmd.Props,
  ): Promise<CreateDiaryEntryCmd.Response> {
    const params: CoreClientDiaryEntriesCreateParams = {
      attachment_ids: props.attachment_ids,
      content: props.content ?? undefined,
      energy_level: props.energy_level ?? undefined,
      mood: props.mood ?? undefined,
      type: props.type,
    };

    const result = await apiRequest<CoreClientDiaryEntriesCreateParams>({
      method: 'client.diary_entries.create',
      params,
    });

    return (result as ApiReadResponse<'diary_entry', CoreDiaryEntryApiModel>)
      .diary_entry;
  }
}
